import React, { ReactNode } from 'react';
import { isEmpty } from 'lodash';
import { TooltipContainer } from '../TooltipContainer/TooltipContainer';
import { ColorType } from '../../../editor/features/beta/styles/colorsByType';
import classNames from 'classnames';

type Props = {
  validation?: string[];
  classPrefix: string;
  position?: 'top' | 'bottom';
  align?: 'start' | 'end' | 'center';
  customIcon?: ReactNode;
  customMessage?: ReactNode;
  type?: ColorType;
  hoverMode?: boolean;
};

export const ErrorTooltip = ({
  validation,
  classPrefix,
  customIcon,
  position,
  customMessage,
  type,
  hoverMode,
  align,
}: Props) => {
  if ((!validation || isEmpty(validation)) && !customMessage) {
    return null;
  }
  const classNamePopoverContainer = `${classPrefix}__popover-container`;
  const classNameContainer = `${classPrefix}__validation-tooltip-container`;
  const classNameContent = `${classPrefix}__validation-tooltip`;
  const classNameAnchor = `${classPrefix}__validation-tooltip-anchor`;
  const classNameIcon = `${classPrefix}__validation-tooltip-icon`;
  return (
    <TooltipContainer
      classNamePopoverContainer={classNamePopoverContainer}
      classNameContainer={classNameContainer}
      classNameContent={classNameContent}
      classNameAnchor={classNameAnchor}
      customIcon={customIcon}
      classNameIconAnchor={classNames(
        'fas fa-exclamation-circle',
        classNameIcon,
      )}
      position={position}
      type={type}
      align={align}
      hoverMode={hoverMode}
      message={
        customMessage || (
          <ul className={`${classPrefix}__validation-messages`}>
            {(validation as string[]).map((message, index) => (
              <li className={`${classPrefix}__validation-message`} key={index}>
                {message}
              </li>
            ))}
          </ul>
        )
      }
    />
  );
};
